import { useEffect } from "react";

const dataTypeValidations: { [key: string]: Set<string> } = {};

export const useMissingDataType = (
  validationId: string,
  key: string | undefined,
  context: string,
  isMissing: boolean // true if should alert
) => {
  useEffect(() => {
    if (!dataTypeValidations[validationId]) {
      dataTypeValidations[validationId] = new Set<string>();
    }

    const set = dataTypeValidations[validationId];

    if (isMissing && key && !set.has(key)) {
      set.add(key);
      console.error(context, set);
    }
  }, [context, key, isMissing, validationId]);
};
